export const clientIdSelector = (state) => (state.clientId);

export const questionnaireSelector = (state) => (state.questionnaire);

export const formDataSelector = (state) => (state.formData);
